import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useI18n } from "../i18n/LanguageContext";
import { LANGUAGES } from "../i18n/translations";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const Seo = ({ titleKey, descKey }) => {
  const { t, lang } = useI18n();
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = t(titleKey);
    setMeta("name", "description", t(descKey));
    setMeta("property", "og:title", t(titleKey));
    setMeta("property", "og:description", t(descKey));
    setMeta("name", "twitter:title", t(titleKey));
    setMeta("name", "twitter:description", t(descKey));

    document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach((n) => n.remove());
    const base = window.location.origin + pathname;
    LANGUAGES.forEach((l) => {
      const link = document.createElement("link");
      link.rel = "alternate";
      link.hreflang = l.code;
      link.href = l.code === "fr" ? base : `${base}?lang=${l.code}`;
      document.head.appendChild(link);
    });
    const xDefault = document.createElement("link");
    xDefault.rel = "alternate";
    xDefault.hreflang = "x-default";
    xDefault.href = base;
    document.head.appendChild(xDefault);
  }, [t, lang, pathname, titleKey, descKey]);

  return null;
};
